import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { taskAPI, userAPI } from '../services/api';
import './TaskList.css';


const isDueDatePassed = (dueDate) => {
  if (!dueDate) return false;
  const now = new Date();
  now.setHours(0, 0, 0, 0); // Today at midnight
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0); // Due date at midnight
  return due < now; // Due date is before today
};

const getStatusColor = (status) => {
switch (status.toLowerCase()) {
case 'assigned': return 'badge-assigned';
case 'not started': return 'badge-not-started';
case 'team review': return 'badge-team-review';
case 'client review': return 'badge-client-review';
case 'rejected by team': return 'badge-rejected-by-team';
case 'rejected by client': return 'badge-rejected-by-client';
case 'approved': return 'badge-approved';
case 'posted': return 'badge-posted';
case 'completed': return 'badge-completed';
case 'in progress': return 'badge-in-progress';
default: return 'badge-default';
}
};

const getClientColor = (client) => {
switch (client.toLowerCase()) {
case 'aakruti': return 'badge-client-aakruti';
case 'amidhara': return 'badge-client-amidhara';
case 'angel': return 'badge-client-angel';
case 'babubhai jewellers': return 'badge-client-babubhai-jewellers';
case 'bela': return 'badge-client-bela';
case 'benbaa': return 'badge-client-benbaa';
case 'eighteen': return 'badge-client-eighteen';
case 'magmino': return 'badge-client-magmino';
case 'miral': return 'badge-client-miral';
case 'neeta': return 'badge-client-neeta';
case 'other': return 'badge-client-other';
case 'rashi': return 'badge-client-rashi';
case 'shakti industries': return 'badge-client-shakti-industries';
case 'shalibhadra rental': return 'badge-client-shalibhadra-rental';
case 'shalibhadra ahm': return 'badge-client-shalibhadra-ahm';
case 'sivi': return 'badge-client-sivi';
case 'sliccily': return 'badge-client-sliccily';
case 'stillman': return 'badge-client-stillman';
case 'surprise': return 'badge-client-surprise';
case 'suryam': return 'badge-client-suryam';
case 'sukanya': return 'badge-client-sukanya';
case 'tantukk': return 'badge-client-tantukk';
default: return 'badge-default';
}
};

const getPriorityColor = (priority) => {
switch (priority.toLowerCase()) {
case 'low': return 'badge-priority-low';
case 'medium': return 'badge-priority-medium';
case 'high': return 'badge-priority-high';
default: return 'badge-default';
}
};

const getPriorityLevel = (priority) => {
switch (priority?.toLowerCase()) {
case 'high': return 3;
case 'medium': return 2;
case 'low': return 1;
default: return 0;
}
};

const getTypeColor = (type) => {
switch (type.toLowerCase()) {
case 'graphic': return 'badge-type-graphic';
case 'reel': return 'badge-type-reel';
case 'post': return 'badge-type-post';
case 'caption #': return 'badge-type-caption';
case 'schedule': return 'badge-type-schedule';
case 'find references': return 'badge-type-find-references';
case 'check data': return 'badge-type-check-data';
case 'story': return 'badge-type-story';
case 'shoot': return 'badge-type-shoot';
case 'other': return 'badge-type-other';
case 'reel+cap' : return 'badge-type-reel-cap';
case 'cap+post' : return 'badge-type-cap-post';
case 'strategy': return 'badge-type-strategy';
default: return 'badge-default';
}
};

const getAssigneeColor = (assignee) => {
const colors = ['badge-assignee-1', 'badge-assignee-2', 'badge-assignee-3', 'badge-assignee-4'];
const hash = assignee.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
return colors[hash % colors.length];
};

const getCreatorColor = (creator) => {
const colors = ['badge-creator-1', 'badge-creator-2', 'badge-creator-3', 'badge-creator-4'];
const hash = creator.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
return colors[hash % colors.length];
};

const clientOptions = [
{ value: 'aakruti', label: 'Aakruti' },
{ value: 'amidhara', label: 'Amidhara' },
{ value: 'angel', label: 'Angel' },
{ value: 'babubhai jewellers', label: 'Babubhai Jewellers' },
{ value: 'bela', label: 'Bela' },
{ value: 'benbaa', label: 'Benbaa' },
{ value: 'eighteen', label: 'Eighteen' },
{ value: 'magmino', label: 'Magmino' },
{ value: 'miral', label: 'Miral' },
{ value: 'neeta', label: 'Neeta' },
{ value: 'other', label: 'Other' },
{ value: 'rashi', label: 'Rashi' },
{ value: 'shakti industires', label: 'Shakti Industries' },
{ value: 'shalibhadra rental', label: 'Shalibhadra Rental' },
{ value: 'shalibhadra ahm', label: 'Shalibhadra AHM' },
{ value: 'sivi', label: 'Sivi' },
{ value: 'sliccily', label: 'Sliccily' },
{ value: 'stillman', label: 'Stillman' },
{ value: 'surprise', label: 'Surprise' },
{ value: 'sukanya', label: 'Sukanya' },
{ value: 'suryam', label: 'Suryam' },
{ value: 'tantukk', label: 'Tantukk' },
];

const priorityOptions = [
{ value: 'low', label: 'Low' },
{ value: 'medium', label: 'Medium' },
{ value: 'high', label: 'High' }
];

const typeOptions = [
{ value: 'graphic', label: 'Graphic' },
{ value: 'reel', label: 'Reel' },
{ value: 'post', label: 'Post' },
{ value: 'caption #', label: 'Caption #' },
{ value: 'schedule', label: 'Schedule' },
{ value: 'find references', label: 'Find References' },
{ value: 'check data', label: 'Check Data' },
{ value: 'story', label: 'Story' },
{ value: 'shoot', label: 'Shoot' },
{ value: 'other', label: 'Other' },
{ value: 'reel+cap', label: 'Reel + Caption#'},
{ value: 'cap+post', label: 'Caption# + Post'},
{ value: 'strategy', label: 'Strategy' }
];

const statusOptions = [
{ value: 'assigned', label: 'Assigned' },
{ value: 'not started', label: 'Not Started' },
{ value: 'in progress', label: 'In Progress' },
{ value: 'team review', label: 'Team Review' },
{ value: 'client review', label: 'Client Review' },
{ value: 'rejected by team', label: 'Rejected By Team' },
{ value: 'rejected by client', label: 'Rejected By Client' },
{ value: 'approved', label: 'Approved' },
{ value: 'completed', label: 'Completed' },
{ value: 'posted', label: 'Posted' }
];

const TaskList = ({ tasks, onUpdate = () => {}, onDelete = () => {}, user }) => {
const [editingTaskId, setEditingTaskId] = useState(null);
const [editedTask, setEditedTask] = useState({});
const [allUsers, setAllUsers] = useState([]);
const [confirmTaskId, setConfirmTaskId] = useState(null);
const [confirmTaskTitle, setConfirmTaskTitle] = useState('');
const [highlightedTasks, setHighlightedTasks] = useState({});
const [taskDetailModal, setTaskDetailModal] = useState(null);
const [taskComments, setTaskComments] = useState([]);
const [showCommentInput, setShowCommentInput] = useState(false);
const [currentComment, setCurrentComment] = useState('');
const [loadingComments, setLoadingComments] = useState(false);
const [savingComment, setSavingComment] = useState(false);
const [localTasks, setLocalTasks] = useState(tasks);
const [isEditingInModal, setIsEditingInModal] = useState(false);
const [modalEditedTask, setModalEditedTask] = useState({});
const [editingField, setEditingField] = useState(null);
const [fieldValue, setFieldValue] = useState('');
const [sortConfig, setSortConfig] = useState({ field: null, direction: null });
const [hiddenStatusOptions, setHiddenStatusOptions] = useState([]);
const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
const [isComponentMounted, setIsComponentMounted] = useState(true);
const [hoveredTaskId, setHoveredTaskId] = useState(null);
const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

const tooltipRef = useRef(null);

const adjustTooltipPosition = (x, y) => {
  if (!tooltipRef.current) return { x, y };
  const tooltipRect = tooltipRef.current.getBoundingClientRect();
  const padding = 12;
  let newX = x + 8;
  let newY = y + 12;

  // Check right edge
  if (newX + tooltipRect.width > window.innerWidth - padding) {
    newX = window.innerWidth - tooltipRect.width - padding;
  }
  // Check bottom edge
  if (newY + tooltipRect.height > window.innerHeight - padding) {
    newY = y - tooltipRect.height - 12;
    if (newY < padding) newY = padding;
  }
  // Check left edge
  if (newX < padding) newX = padding;
  // Check top edge
  if (newY < padding) newY = padding;

  return { x: newX, y: newY };
};


useEffect(() => {
return () => {
setIsComponentMounted(false);
// Cancel any pending requests
if (updateFieldTimeoutRef.current) {
clearTimeout(updateFieldTimeoutRef.current);
}
};
}, []);

// 🔧 FIX 1: Use refs to prevent infinite updates
const tasksRef = useRef(tasks);
const isUpdatingRef = useRef(false);

// Filter states
const [filters, setFilters] = useState({
client: '',
priority: '',
task_type: '',
status: [],
assignee: '',
assigned_by: '',
due_date_from: '',
due_date_to: ''
});
const [showFilters, setShowFilters] = useState(false);

// 🔧 FIX 2: Memoized callbacks to prevent re-renders
const handleStatusOptionClick = useCallback((statusValue) => {
setFilters(prevFilters => {
const currentStatus = prevFilters.status;
const isSelected = currentStatus.includes(statusValue);
const isHidden = hiddenStatusOptions.includes(statusValue);

if (!isSelected && !isHidden) {
return {
...prevFilters,
status: [...currentStatus, statusValue]
};
} else if (isSelected && !isHidden) {
setHiddenStatusOptions(prev => [...prev, statusValue]);
return {
...prevFilters,
status: currentStatus.filter(status => status !== statusValue)
};
} else if (isHidden) {
setHiddenStatusOptions(prev => prev.filter(status => status !== statusValue));
return prevFilters;
}

return prevFilters;
});
}, [hiddenStatusOptions]);

const handleSort = useCallback((field) => {
let direction = 'asc';

if (sortConfig.field === field) {
if (sortConfig.direction === 'asc') {
direction = 'desc';
} else if (sortConfig.direction === 'desc') {
direction = null;
} else {
direction = 'asc';
}
}

setSortConfig({ field, direction });
}, [sortConfig]);

const getSortIcon = useCallback((field) => {
if (sortConfig.field !== field || sortConfig.direction === null) {
return <span className="sort-icon sort-neutral">↕️</span>;
}

if (sortConfig.direction === 'asc') {
return <span className="sort-icon sort-asc">↑</span>;
} else {
return <span className="sort-icon sort-desc">↓</span>;
}
}, [sortConfig]);

// 🔧 FIX 3: Debounced field update to prevent multiple API calls
const updateFieldTimeoutRef = useRef(null);

const handleFieldBlur = useCallback(async () => {
  if (!editingField || isUpdatingRef.current || !isComponentMounted) return;

  const currentValue = taskDetailModal[editingField];
  let hasChanged = false;

  if (editingField === 'assignees_ids') {
    const currentIds = taskDetailModal.assignees?.map(a => a.id) || [];
    hasChanged = JSON.stringify(currentIds.sort()) !== JSON.stringify(fieldValue.sort());
  } else {
    hasChanged = String(currentValue || '') !== String(fieldValue || '');
  }

  if (!hasChanged) {
    setEditingField(null);
    setFieldValue('');
    return;
  }

  isUpdatingRef.current = true;

  // Prepare optimistic updatedTask
  const optimisticTask = {
    ...taskDetailModal,
    [editingField]: fieldValue
  };

  if (editingField === 'assignees_ids') {
    optimisticTask.assignees = fieldValue.map(id =>
      allUsers.find(user => user.id === id)
    ).filter(Boolean);
  }

  // Optimistic local updates
  setTaskDetailModal(optimisticTask);
  setLocalTasks(prevTasks =>
    prevTasks.map(task =>
      task.id === optimisticTask.id
        ? { ...task, ...optimisticTask }
        : task
    )
  );

  setHighlightedTasks(prev => ({
    ...prev,
    [taskDetailModal.id]: [editingField]
  }));

  setEditingField(null);
  setFieldValue('');

  try {
    const payload = {
  ...optimisticTask,
  due_date: editingField === 'due_date'
    ? (fieldValue ? new Date(fieldValue).toISOString().split('T')[0] : null)
    : optimisticTask.due_date || null,
  due_time: editingField === 'due_time'
    ? (fieldValue || null)
    : optimisticTask.due_time || null,
  assignees_ids: optimisticTask.assignees?.map(a => a.id) || []
};


    const response = await taskAPI.updateTask(optimisticTask.id, payload);

    if (onUpdate && typeof onUpdate === 'function') {
      setTimeout(() => {
        onUpdate(optimisticTask.id, response.data);
      }, 0);
    }

  } catch (error) {
    console.error('Failed to update task:', error);
    alert(`Failed to update ${editingField}. Please try again.`);
    // rollback if needed
  } finally {
    isUpdatingRef.current = false;
  }
}, [editingField, fieldValue, taskDetailModal, allUsers, onUpdate, isComponentMounted]);


// 🔧 FIX 7: Optimized field click handler
const handleFieldClick = useCallback((fieldName) => {
if (editingField) return; // Prevent multiple edits at once

if (fieldName === 'assignees_ids') {
setFieldValue(taskDetailModal.assignees?.map(a => a.id) || []);
} else if (fieldName === 'due_date') {
if (taskDetailModal.due_date) {
try {
const dateObj = new Date(taskDetailModal.due_date);
if (taskDetailModal.due_date.length === 10) {
dateObj.setHours(12, 0, 0, 0);
}
setFieldValue(dateObj.toISOString().slice(0, 16));
} catch (error) {
console.error('Error formatting date:', error);
setFieldValue('');
}
} else {
setFieldValue('');
}
} else if (fieldName === 'due_time') {
const timeValue = taskDetailModal.due_time || '';
const formattedTime = timeValue.length > 5 ? timeValue.slice(0, 5) : timeValue;
setFieldValue(formattedTime);
} else {
setFieldValue(taskDetailModal[fieldName] || '');
}
setEditingField(fieldName);
}, [editingField, taskDetailModal]);

const handleFieldChange = useCallback((value) => {
setFieldValue(value);
}, []);

// In your parent component, make sure onUpdate doesn't trigger a full refresh
// const handleTaskUpdate = useCallback((taskId, updatedData) => {
// // Update specific task instead of refetching all
// setTasks(prevTasks =>
// prevTasks.map(task =>
// task.id === taskId ? { ...task, ...updatedData } : task
// )
// );
// // Don't call fetchTasks() here!
// }, []);

// 🔧 FIX 8: Fetch users only once
React.useEffect(() => {
let isMounted = true;

const fetchUsers = async () => {
try {
const response = await userAPI.getUsers();
if (isMounted) {
setAllUsers(response.data);
}
} catch (error) {
console.error('Failed to fetch users:', error);
if (isMounted) {
setAllUsers([]);
}
}
};

fetchUsers();

return () => {
isMounted = false;
};
}, []); // Empty dependency array - only run once

// 🔧 FIX 9: Optimized tasks update effect with proper comparison and duplicate prevention
useEffect(() => {
if (!tasks || isUpdatingRef.current) return;

// Use a stable reference comparison to avoid unnecessary updates
const newTaskIds = tasks.map(t => t.id).join(',');
const oldTaskIds = tasksRef.current?.map(t => t.id).join(',');

if (newTaskIds !== oldTaskIds) {
console.log('Tasks prop updated:', tasks.length, 'tasks');
setLocalTasks(tasks);
tasksRef.current = tasks;
}
}, [tasks]); // Keep dependencies minimal


// 🔧 FIX 10: Optimized modal task update with better change detection
React.useEffect(() => {
if (taskDetailModal && tasks && !isUpdatingRef.current) {
const updatedModalTask = tasks.find(t => t.id === taskDetailModal.id);
if (updatedModalTask) {
// Only update if there are actual changes - use specific field comparison for efficiency
const hasChanges = 
  updatedModalTask.title !== taskDetailModal.title ||
  updatedModalTask.status !== taskDetailModal.status ||
  updatedModalTask.priority !== taskDetailModal.priority ||
  JSON.stringify(updatedModalTask.assignees) !== JSON.stringify(taskDetailModal.assignees);
  
if (hasChanges) {
console.log('Updating modal task with changes detected');
setTaskDetailModal(updatedModalTask);
}
}
}
}, [tasks, taskDetailModal?.id]); // Keep minimal dependencies

// Get unique values for filter options
const getUniqueValues = useCallback((field) => {
const values = new Set();
localTasks.forEach(task => {
if (field === 'assignee') {
task.assignees?.forEach(assignee => {
if (assignee.username) values.add(assignee.username);
});
} else if (field === 'assigned_by') {
const creator = task.creator?.username || task.created_by?.username;
if (creator) values.add(creator);
} else {
const value = task[field];
if (value && value !== '') values.add(value);
}
});
return Array.from(values).sort();
}, [localTasks]);

// 🔧 FIX 11: Optimized filtered tasks with stable dependencies
const filteredTasks = useMemo(() => {
let filtered = localTasks.filter(task => {
// Client filter
if (filters.client && task.client?.toLowerCase() !== filters.client.toLowerCase()) {
return false;
}

// Priority filter
if (filters.priority && task.priority?.toLowerCase() !== filters.priority.toLowerCase()) {
return false;
}

// Task type filter
if (filters.task_type && task.task_type?.toLowerCase() !== filters.task_type.toLowerCase()) {
return false;
}

// Status filter - hidden options
if (hiddenStatusOptions.length > 0) {
const taskStatusMatches = hiddenStatusOptions.some(hiddenStatus =>
task.status?.toLowerCase() === hiddenStatus.toLowerCase()
);
if (taskStatusMatches) return false;
}

// Status filter - selected options
if (filters.status && filters.status.length > 0) {
const hasMatchingStatus = filters.status.some(selectedStatus =>
task.status?.toLowerCase() === selectedStatus.toLowerCase()
);
if (!hasMatchingStatus) return false;
}

// Assignee filter
if (filters.assignee) {
const hasAssignee = task.assignees?.some(assignee =>
assignee.username?.toLowerCase() === filters.assignee.toLowerCase()
);
if (!hasAssignee) return false;
}

// Assigned by filter
if (filters.assigned_by) {
const creator = task.creator?.username || task.created_by?.username;
if (creator?.toLowerCase() !== filters.assigned_by.toLowerCase()) {
return false;
}
}

// Due date range filter
if (filters.due_date_from || filters.due_date_to) {
const taskDate = task.due_date ? new Date(task.due_date) : null;
if (!taskDate) return false;

if (filters.due_date_from) {
const fromDate = new Date(filters.due_date_from);
if (taskDate < fromDate) return false;
}

if (filters.due_date_to) {
const toDate = new Date(filters.due_date_to);
if (taskDate > toDate) return false;
}
}

return true;
});

// Apply sorting only if direction is not null
if (sortConfig.field && sortConfig.direction) {
filtered.sort((a, b) => {
if (sortConfig.field === 'priority') {
const aLevel = getPriorityLevel(a.priority);
const bLevel = getPriorityLevel(b.priority);

if (sortConfig.direction === 'asc') {
return aLevel - bLevel;
} else {
return bLevel - aLevel;
}
} else if (sortConfig.field === 'due_date') {
const aDate = a.due_date ? new Date(a.due_date) : null;
const bDate = b.due_date ? new Date(b.due_date) : null;

if (!aDate && !bDate) return 0;
if (!aDate) return 1;
if (!bDate) return -1;

if (sortConfig.direction === 'asc') {
return aDate - bDate;
} else {
return bDate - aDate;
}
}
return 0;
});
}

return filtered;
}, [localTasks, filters, sortConfig, hiddenStatusOptions]);

// Handle filter changes
const handleFilterChange = useCallback((field, value) => {
setFilters(prev => ({
...prev,
[field]: value
}));
}, []);

// Clear all filters
const clearAllFilters = useCallback(() => {
setFilters({
client: '',
priority: '',
task_type: '',
status: [],
assignee: '',
assigned_by: '',
due_date_from: '',
due_date_to: ''
});
setHiddenStatusOptions([]);
setIsStatusDropdownOpen(false);
}, []);

// Check if any filters are active
const hasActiveFilters = useMemo(() => {
return Object.entries(filters).some(([key, value]) => {
if (key === 'status') {
return Array.isArray(value) && value.length > 0;
}
return value !== '';
}) || hiddenStatusOptions.length > 0;
}, [filters, hiddenStatusOptions]);

const handleDeleteClick = useCallback((id, title) => {
setConfirmTaskId(id);
setConfirmTaskTitle(title);
}, []);

const handleConfirmDelete = useCallback(() => {
onDelete(confirmTaskId);
setConfirmTaskId(null);
setConfirmTaskTitle('');
}, [confirmTaskId, onDelete]);

const handleCancel = useCallback(() => {
setConfirmTaskId(null);
setConfirmTaskTitle('');
}, []);

// 🔧 FIX 12: Prevent multiple comment loads
const loadingCommentsRef = useRef(false);

const handleInfoClick = useCallback(async (task) => {
if (loadingCommentsRef.current) return;

setTaskDetailModal(task);
setLoadingComments(true);
loadingCommentsRef.current = true;

try {
const response = await taskAPI.getTaskComments(task.id);
setTaskComments(response.data);
} catch (error) {
console.error('Failed to load comments:', error);
setTaskComments([]);
} finally {
setLoadingComments(false);
loadingCommentsRef.current = false;
}
}, []);

const closeTaskDetailModal = useCallback(() => {
setTaskDetailModal(null);
setShowCommentInput(false);
setCurrentComment('');
setTaskComments([]);
setIsEditingInModal(false);
setModalEditedTask({});
setEditingField(null);
setFieldValue('');
loadingCommentsRef.current = false;
}, []);

const handleAddComment = useCallback(() => {
setShowCommentInput(true);
}, []);

// 🔧 FIX 13: Prevent multiple comment saves
const savingCommentRef = useRef(false);

const handleSaveComment = useCallback(async () => {
if (!currentComment.trim() || !taskDetailModal || savingCommentRef.current) return;

setSavingComment(true);
savingCommentRef.current = true;

try {
const response = await taskAPI.addTaskComment(taskDetailModal.id, {
text: currentComment.trim()
});

setTaskComments(prev => [...prev, response.data]);
setCurrentComment('');
setShowCommentInput(false);
} catch (error) {
console.error('Failed to save comment:', error);
alert(`Failed to save comment: ${error.message}`);
} finally {
setSavingComment(false);
savingCommentRef.current = false;
}
}, [currentComment, taskDetailModal]);

const handleCancelComment = useCallback(() => {
setCurrentComment('');
setShowCommentInput(false);
}, []);

const formatCommentDate = useCallback((dateString) => {
const date = new Date(dateString);
return date.toLocaleString('en-US', {
month: 'short',
day: 'numeric',
year: 'numeric',
hour: '2-digit',
minute: '2-digit'
});
}, []);

const formatDate = useCallback((dateString) => {
if (!dateString) return 'Not set';

try {
const date = new Date(dateString);

if (isNaN(date.getTime())) return 'Invalid date';

const day = date.getDate().toString().padStart(2, '0');
const month = (date.getMonth() + 1).toString().padStart(2, '0');
const year = date.getFullYear();

return `${day}-${month}-${year}`;
} catch (error) {
return 'Invalid date';
}
}, []);

const handleChange = useCallback((field, value) => {
setEditedTask((prev) => ({ ...prev, [field]: value }));
}, []);

const renderEditableCell = useCallback((task, field, type, options = []) => {
const isEditing = editingTaskId === task.id;
const value = isEditing ? editedTask[field] : task[field] || '';
const isHighlighted = highlightedTasks[task.id]?.includes(field);

const className = isHighlighted ? 'highlight-cell' : '';

if (isEditing) {
if (type === 'dropdown') {
return (
<select className={className} value={value} onChange={(e) => handleChange(field, e.target.value)}>
<option value="">Select</option>
{options.map((opt) => (
<option key={opt.value} value={opt.value}>{opt.label}</option>
))}
</select>
);
}

if (type === 'multi-select') {
return (
<select
className={className}
multiple
value={value || []}
onChange={(e) => {
const selectedValues = Array.from(e.target.selectedOptions, option => parseInt(option.value));
handleChange(field, selectedValues);
}}
style={{ minHeight: '80px' }}
>
{options.map((opt) => (
<option key={opt.value} value={opt.value}>{opt.label}</option>
))}
</select>
);
}

if (type === 'datetime') {
return (
<input
className={className}
type="datetime-local"
value={value}
onChange={(e) => handleChange(field, e.target.value)}
/>
);
}

return (
<input
className={className}
type="text"
value={value}
onChange={(e) => handleChange(field, e.target.value)}
/>
);
}

// Non-editing mode - render colored badges for specific fields
if (field === 'status') {
return (
<span className={className}>
<span className={`badge ${getStatusColor(task.status)}`}>{value}</span>
</span>
);
}

if (field === 'client') {
return (
<span className={className}>
{value ? <span className={`badge ${getClientColor(value)}`}>{value}</span> : '—'}
</span>
);
}

if (field === 'priority') {
return (
<span className={className}>
{value ? <span className={`badge ${getPriorityColor(value)}`}>{value}</span> : '—'}
</span>
);
}

if (field === 'task_type') {
return (
<span className={className}>
{value ? <span className={`badge ${getTypeColor(value)}`}>{value}</span> : '—'}
</span>
);
}

if (field === 'due_date') {
return (
<span className={className}>
{formatDate(value)}
</span>
);
}

if (field === 'id') {
return (
<span className={`task-id ${className}`}>
#{value}
</span>
);
}

return (
<span className={className}>
{value || '—'}
</span>
);
}, [editingTaskId, editedTask, highlightedTasks, handleChange, formatDate]);

const renderTextWithLinks = useCallback((text) => {
if (!text) return text;

const urlRegex = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+|www\.[^\s<>"{}|\\^`\[\]]+|[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}(?:\/[^\s<>"{}|\\^`\[\]]*)?)/gi;

const parts = text.split(urlRegex);

return parts.map((part, index) => {
if (urlRegex.test(part)) {
urlRegex.lastIndex = 0;

let fullUrl = part;
if (!part.startsWith('http://') && !part.startsWith('https://')) {
fullUrl = 'https://' + part;
}

return (
<a
key={index}
href={fullUrl}
target="_blank"
rel="noopener noreferrer"
className="text-link"
onClick={(e) => e.stopPropagation()}
>
{part}
</a>
);
}

return part;
});
}, []);

// 🔧 FIX 14: Cleanup timeouts on unmount
React.useEffect(() => {
return () => {
if (updateFieldTimeoutRef.current) {
clearTimeout(updateFieldTimeoutRef.current);
}
};
}, []);

return (
<div className="task-table-wrapper">
{/* Filter Section */}
<div className="filter-section">
<div className="filter-header">
<button
className={`filter-toggle-btn ${showFilters ? 'active' : ''}`}
onClick={() => setShowFilters(!showFilters)}
>
🔍 Filters {hasActiveFilters && <span className="filter-count">({Object.values(filters).filter(f => f !== '').length})</span>}
</button>
{hasActiveFilters && (
<button className="clear-filters-btn" onClick={clearAllFilters}>
Clear All
</button>
)}
<div className="results-count">
Showing {filteredTasks.length} of {localTasks.length} tasks
</div>
</div>

{showFilters && (
<div className="filter-controls">
<div className="filter-row">
{/* Client Filter */}
<div className="filter-group">
<label>Client:</label>
<select
value={filters.client}
onChange={(e) => handleFilterChange('client', e.target.value)}
>
<option value="">All Clients</option>
{clientOptions.map(option => (
<option key={option.value} value={option.value}>
{option.label}
</option>
))}
</select>
</div>

{/* Priority Filter */}
<div className="filter-group">
<label>Priority:</label>
<select
value={filters.priority}
onChange={(e) => handleFilterChange('priority', e.target.value)}
>
<option value="">All Priorities</option>
{priorityOptions.map(option => (
<option key={option.value} value={option.value}>
{option.label}
</option>
))}
</select>
</div>

{/* Type Filter */}
<div className="filter-group">
<label>Type:</label>
<select
value={filters.task_type}
onChange={(e) => handleFilterChange('task_type', e.target.value)}
>
<option value="">All Types</option>
{typeOptions.map(option => (
<option key={option.value} value={option.value}>
{option.label}
</option>
))}
</select>
</div>

{/* Status Filter */}
<div className="filter-group">
<label>Status:</label>
<div className="status-filter-wrapper">
<div
className="status-filter-toggle"
onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
>
<span>
{filters.status.length > 0 || hiddenStatusOptions.length > 0
? `${filters.status.length} selected${hiddenStatusOptions.length > 0 ? `, ${hiddenStatusOptions.length} hidden` : ''}`
: 'Select Status'
}
</span>
<span className={`dropdown-arrow ${isStatusDropdownOpen ? 'open' : ''}`}>▼</span>
</div>

{isStatusDropdownOpen && (
<div className="status-filter-container">
{statusOptions.map(option => {
const isSelected = filters.status.includes(option.value);
const isHidden = hiddenStatusOptions.includes(option.value);

return (
<div
key={option.value}
className={`status-option ${isSelected ? 'selected' : ''} ${isHidden ? 'hidden' : ''}`}
onClick={() => handleStatusOptionClick(option.value)}
>
<span className="status-label">{option.label}</span>
{isSelected && <span className="status-indicator">✓</span>}
{isHidden && <span className="status-indicator">✗</span>}
</div>
);
})}
</div>
)}
</div>

{filters.status.length > 0 && (
<div className="selected-items">
Selected: {filters.status.map(status =>
statusOptions.find(opt => opt.value === status)?.label
).join(', ')}
</div>
)}
{hiddenStatusOptions.length > 0 && (
<div className="hidden-items">
Hidden: {hiddenStatusOptions.map(status =>
statusOptions.find(opt => opt.value === status)?.label
).join(', ')}
</div>
)}
</div>
</div>

<div className="filter-row">
{/* Assignee Filter */}
<div className="filter-group">
<label>Assignee:</label>
<select
value={filters.assignee}
onChange={(e) => handleFilterChange('assignee', e.target.value)}
>
<option value="">All Assignees</option>
{getUniqueValues('assignee').map(assignee => (
<option key={assignee} value={assignee}>
{assignee}
</option>
))}
</select>
</div>

{/* Assigned By Filter */}
<div className="filter-group">
<label>Assigned By:</label>
<select
value={filters.assigned_by}
onChange={(e) => handleFilterChange('assigned_by', e.target.value)}
>
<option value="">All Creators</option>
{getUniqueValues('assigned_by').map(creator => (
<option key={creator} value={creator}>
{creator}
</option>
))}
</select>
</div>

{/* Due Date Filter */}
<div className="filter-group date-range">
<label>Due Date:</label>
<div className="date-range-inputs">
<input
type="date"
value={filters.due_date_from}
onChange={(e) => handleFilterChange('due_date_from', e.target.value)}
placeholder="From"
/>
<span>to</span>
<input
type="date"
value={filters.due_date_to}
onChange={(e) => handleFilterChange('due_date_to', e.target.value)}
placeholder="To"
/>
</div>
</div>
</div>
</div>
)}
</div>

<table className="task-table">
<thead>
<tr>
<th>ID</th>
<th>Client</th>
<th>Task</th>
<th
className="sortable-header"
onClick={() => handleSort('priority')}
title="Click to sort by priority (cycles: Ascending → Descending → No Sort)"
>
Priority {getSortIcon('priority')}
</th>
<th>Type</th>
<th>Status</th>
<th
className="sortable-header"
onClick={() => handleSort('due_date')}
title="Click to sort by due date (cycles: Ascending → Descending → No Sort)"
>
Due Date & Time {getSortIcon('due_date')}
</th>
<th>Assignee</th>
<th>Assigned By</th>
{user?.role === 'admin' && (<th>Actions</th>)}
</tr>
</thead>
<tbody>
{filteredTasks.map((task) => {
  const isHighPriority = (task.priority || '').toLowerCase() === 'high';
  const isDuePassed = isDueDatePassed(task.due_date);
  const isMyTask = task.assignees?.some(a => a.id === user?.id);

  // Do NOT flicker if status is Approved, Completed, or Posted
  const statusNoFlicker = ['rejected by client', 'approved', 'completed', 'posted'];
  const isNoFlickerStatus = statusNoFlicker.includes((task.status || '').toLowerCase());

  // Flicker if high priority OR due date is passed, and is my task, and not in no-flicker statuses
  const flickerClass =
    (isHighPriority || isDuePassed) && isMyTask && !isNoFlickerStatus
      ? 'flicker-highlight'
      : '';

  return (
    <tr
      key={task.id}
      className={`${highlightedTasks[task.id] ? 'highlight-row' : ''} clickable-row ${flickerClass}`}
      onClick={(e) => {
        // Prevent opening modal if clicking on action buttons or input fields
        if (
          e.target.closest('.actions-cell') ||
          e.target.tagName === 'INPUT' ||
          e.target.tagName === 'SELECT' ||
          e.target.tagName === 'BUTTON'
        ) {
          return;
        }
        // Clear highlights if any
        if (highlightedTasks[task.id]) {
          setHighlightedTasks(prev => {
            const copy = { ...prev };
            delete copy[task.id];
            return copy;
          });
        }
        // Open task detail modal
        handleInfoClick(task);
      }}
    >
      <td><span className="task-id">#{task.id}</span></td>
      <td>{renderEditableCell(task, 'client', 'dropdown', clientOptions)}</td>
     <td
  onMouseEnter={e => {
    setHoveredTaskId(task.id);
    setTooltipPosition({ x: e.clientX, y: e.clientY });
  }}
  onMouseMove={e => {
    setTooltipPosition({ x: e.clientX, y: e.clientY });
  }}
  onMouseLeave={() => setHoveredTaskId(null)}
  style={{ position: 'relative' }}
>
  {renderEditableCell(task, 'title', 'text')}
  {hoveredTaskId === task.id && task.description && (
    <div
      ref={tooltipRef}
      className="task-tooltip"
      style={{
        position: 'fixed',
        zIndex: 9999,
        maxWidth: 320,
        pointerEvents: 'none',
        ...(() => {
          // Adjust position after render
          const { x, y } = adjustTooltipPosition(tooltipPosition.x, tooltipPosition.y);
          return { top: y, left: x };
        })(),
      }}
    >
      {task.description}
    </div>
  )}
</td>
      <td>{renderEditableCell(task, 'priority', 'dropdown', priorityOptions)}</td>
      <td>{renderEditableCell(task, 'task_type', 'dropdown', typeOptions)}</td>
      <td>{renderEditableCell(task, 'status', 'dropdown', statusOptions)}</td>
      <td>
        {editingTaskId === task.id ? (
          renderEditableCell(task, 'due_date', 'datetime')
        ) : (
          <span className={highlightedTasks[task.id]?.includes('due_date') ? 'highlight-cell' : ''}>
            {formatDate(task.due_date)} {(task.due_time)}
          </span>
        )}
      </td>
      <td>
        {editingTaskId === task.id ? (
          renderEditableCell(
            task,
            'assignees_ids',
            'multi-select',
            allUsers.map(user => ({ value: user.id, label: user.username }))
          )
        ) : (
          <span className={`badge ${getAssigneeColor(task.assignees?.[0]?.username || 'Unassigned')}`}>
            {task.assignees?.map((a) => a.username).join(', ') || 'Unassigned'}
          </span>
        )}
      </td>
      <td>
        <div className="creator-cell">
          <span className={`badge ${getCreatorColor(task.creator?.username || task.created_by?.username || 'Unknown')}`}>
            {task.creator?.username || task.created_by?.username || 'Unknown'}
          </span>
        </div>
      </td>
      <td className="actions-cell" onClick={(e) => e.stopPropagation()}>
        {user?.role === 'admin' && (
          <button className="delete-btn" onClick={() => handleDeleteClick(task.id, task.title)}>🗑️</button>
        )}
      </td>
    </tr>
  );
})}
</tbody>
</table>

{filteredTasks.length === 0 && localTasks.length > 0 && (
<div className="no-results">
<p>No tasks match the current filters.</p>
<button onClick={clearAllFilters}>Clear Filters</button>
</div>
)}

{/* Delete Confirmation Modal */}
{confirmTaskId && (
<div className="confirm-overlay">
<div className="confirm-box">
<p>Are you sure you want to delete <strong>"{confirmTaskTitle}"</strong>?</p>
<div className="confirm-actions">
<button className="btn confirm" onClick={handleConfirmDelete}>Yes</button>
<button className="btn cancel" onClick={handleCancel}>No</button>
</div>
</div>
</div>
)}

{/* Task Detail Modal */}
{taskDetailModal && (
<div className="task-detail-overlay" onClick={closeTaskDetailModal}>
<div className="task-detail-modal" onClick={(e) => e.stopPropagation()}>
<div className="task-detail-header">
<h2>Task Details</h2>
<div className="modal-header-actions">
<button className="close-btn" onClick={closeTaskDetailModal}>✕</button>
</div>
</div>

<div className="task-detail-content">
<div className="task-detail-section">
<h3>Basic Information</h3>
<div className="detail-row">
<label>ID:</label>
<span className="task-id">#{taskDetailModal.id}</span>
</div>

{/* Editable Title */}
<div className="detail-row">
<label>Title:</label>
{editingField === 'title' ? (
<input
type="text"
value={fieldValue}
onChange={(e) => handleFieldChange(e.target.value)}
onBlur={handleFieldBlur}
className="modal-edit-input inline-edit"
autoFocus
/>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('title')}
title="Click to edit"
>
{taskDetailModal.title || 'Click to add title'}
</span>
)}
</div>

{/* Editable Description */}
<div className="detail-row description-row">
<label>Description:</label>
<div className="description-content">
{editingField === 'description' ? (
<textarea
value={fieldValue}
onChange={(e) => handleFieldChange(e.target.value)}
onBlur={handleFieldBlur}
className="modal-edit-textarea inline-edit"
rows={3}
autoFocus
/>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('description')}
title="Click to edit"
>
{taskDetailModal.description ? (
<div className="description-with-links">
{renderTextWithLinks(taskDetailModal.description)}
</div>
) : 'Click to add description'}
</span>
)}
<button
className="comment-btn"
onClick={handleAddComment}
title="Add comment"
>
💬
</button>
</div>
</div>

{/* Comment Input */}
{showCommentInput && (
<div className="comment-input-section">
<textarea
value={currentComment}
onChange={(e) => setCurrentComment(e.target.value)}
placeholder="Add your comment here..."
className="comment-textarea"
rows={3}
disabled={savingComment}
/>
<div className="comment-actions">
<button
className="save-comment-btn"
onClick={handleSaveComment}
disabled={savingComment || !currentComment.trim()}
>
{savingComment ? 'Saving...' : 'Save'}
</button>
<button
className="cancel-comment-btn"
onClick={handleCancelComment}
disabled={savingComment}
>
Cancel
</button>
</div>
</div>
)}

{/* Comments Section */}
{loadingComments ? (
<div className="comments-loading">Loading comments...</div>
) : (
taskComments && taskComments.length > 0 && (
<div className="comments-section">
<h4>Comments:</h4>
{taskComments.map((comment) => (
<div key={comment.id} className="comment-item">
<div className="comment-header">
<span className="comment-author">{comment.author.username}</span>
<span className="comment-timestamp">{formatCommentDate(comment.created_at)}</span>
</div>
<div className="comment-text">
{renderTextWithLinks(comment.text)}
</div>
</div>
))}
</div>
)
)}

<div className="detail-row">
<label>Client:</label>
<span>
{taskDetailModal.client ? (
<span className={`badge ${getClientColor(taskDetailModal.client)}`}>
{taskDetailModal.client}
</span>
) : 'Not assigned'}
</span>
</div>
</div>

<div className="task-detail-section">
<h3>Task Properties</h3>
<div className="detail-row">
<label>Type:</label>
<span>
{taskDetailModal.task_type ? (
<span className={`badge ${getTypeColor(taskDetailModal.task_type)}`}>
{taskDetailModal.task_type}
</span>
) : 'Not specified'}
</span>
</div>

{/* Editable Priority */}
<div className="detail-row">
<label>Priority:</label>
{editingField === 'priority' ? (
<select
value={fieldValue}
onChange={(e) => handleFieldChange(e.target.value)}
onBlur={handleFieldBlur}
className="modal-edit-select inline-edit"
autoFocus
>
<option value="">Select Priority</option>
{priorityOptions.map((opt) => (
<option key={opt.value} value={opt.value}>{opt.label}</option>
))}
</select>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('priority')}
title="Click to edit"
>
{taskDetailModal.priority ? (
<span className={`badge ${getPriorityColor(taskDetailModal.priority)}`}>
{taskDetailModal.priority}
</span>
) : 'Click to set priority'}
</span>
)}
</div>

{/* Editable Status */}
<div className="detail-row">
<label>Status:</label>
{editingField === 'status' ? (
<select
value={fieldValue}
onChange={(e) => handleFieldChange(e.target.value)}
onBlur={handleFieldBlur}
className="modal-edit-select inline-edit"
autoFocus
>
<option value="">Select Status</option>
{statusOptions.map((opt) => (
<option key={opt.value} value={opt.value}>{opt.label}</option>
))}
</select>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('status')}
title="Click to edit"
>
<span className={`badge ${getStatusColor(taskDetailModal.status)}`}>
{taskDetailModal.status || 'Click to set status'}
</span>
</span>
)}
</div>
</div>

<div className="task-detail-section">
<h3>Assignment & Timeline</h3>

{/* Editable Assignees */}
<div className="detail-row">
<label>Assignees:</label>
{editingField === 'assignees_ids' ? (
<select
multiple
value={fieldValue}
onChange={(e) => {
const selectedValues = Array.from(e.target.selectedOptions, option => parseInt(option.value));
handleFieldChange(selectedValues);
}}
onBlur={handleFieldBlur}
className="modal-edit-multiselect inline-edit"
autoFocus
>
{allUsers.map((user) => (
<option key={user.id} value={user.id}>{user.username}</option>
))}
</select>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('assignees_ids')}
title="Click to edit"
>
{taskDetailModal.assignees && taskDetailModal.assignees.length > 0 ? (
<div className="assignees-list">
{taskDetailModal.assignees.map((assignee, index) => (
<span key={index} className={`badge ${getAssigneeColor(assignee.username)}`}>
{assignee.username}
</span>
))}
</div>
) : 'Click to assign users'}
</span>
)}
</div>

<div className="detail-row">
<label>Assigned By:</label>
<span>
{taskDetailModal.creator?.username || taskDetailModal.created_by?.username ? (
<span className={`badge ${getCreatorColor(taskDetailModal.creator?.username || taskDetailModal.created_by?.username)}`}>
{taskDetailModal.creator?.username || taskDetailModal.created_by?.username}
</span>
) : 'Unknown'}
</span>
</div>
<div className="detail-row">
<label>Created Date:</label>
<span>{formatDate(taskDetailModal.created_at)}</span>
</div>

{/* Editable Due Date */}
<div className="detail-row">
<label>Due Date:</label>
{editingField === 'due_date' ? (
<input
type="datetime-local"
value={fieldValue}
onChange={(e) => handleFieldChange(e.target.value)}
onBlur={handleFieldBlur}
className="modal-edit-input inline-edit"
autoFocus
/>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('due_date')}
title="Click to edit"
>
{formatDate(taskDetailModal.due_date) !== 'Not set' ?
formatDate(taskDetailModal.due_date) : 'Click to set due date'}
</span>
)}
</div>

<div className="detail-row">
<label>Due Time:</label>
{editingField === 'due_time' ? (
<input
type="time"
value={fieldValue}
onChange={(e) => handleFieldChange(e.target.value)}
onBlur={handleFieldBlur}
className="modal-edit-input inline-edit"
autoFocus
/>
) : (
<span
className="editable-field"
onClick={() => handleFieldClick('due_time')}
title="Click to edit"
>
{taskDetailModal.due_time || 'Click to set due time'}
</span>
)}
</div>

 {/* Last Edited Info */}
  <div className="detail-row">
    <label>Last Edited By:</label>
   <span>
  {taskDetailModal.updated_by || '—'}
</span>
  </div>
  <div className="detail-row">
    <label>Last Edited At:</label>
    <span>
      {taskDetailModal.updated_at
        ? formatCommentDate(taskDetailModal.updated_at)
        : '—'}
    </span>
  </div>
</div>

{taskDetailModal.id && (
<div className="task-detail-section">
<h3>System Information</h3>
<div className="detail-row">
<label>Task ID:</label>
<span className="task-id">#{taskDetailModal.id}</span>
</div>
</div>
)}
</div>
</div>
</div>
)}
</div>
);
};

export default TaskList;